// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import SitePlayer from 'components/NowPlaying/SitePlayer'
import SiteNotice from 'components/SiteNotice/SiteNotice'
import NowPlaying from 'components/NowPlaying/NowPlaying'
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary'
import LoadScript from 'containers/LoadScript'
import { getUrlParameter } from 'utilities/url'

// Redux:
import { setSiteId, getFullScheduleData } from 'actions/schedule'

class EmbeddedPlayer extends React.Component {
	componentDidMount() {
		const siteId = getUrlParameter( 'siteid' ) || 'AICE'

		// Switch siteId, without saving to storage:
		this.props.dispatch( setSiteId( siteId, false, true ) )
		this.props.dispatch( getFullScheduleData() )

		document.documentElement.classList.add( 'with-embedded-player' )
	}

	componentWillUnmount() {
		document.documentElement.classList.remove( 'with-embedded-player' )
	}

	render() {
		const { siteNotice } = this.props
		const siteid = getUrlParameter( 'siteid' ) || 'AICE'
		const version = getUrlParameter( 'v' ) || 'default'
		const isPreview = getUrlParameter( 'pr' )
		let className = `embedded-player is-v-${version}`

		if ( isPreview ) {
			className += ' is-preview'
		}

		let showMiniSchedule = false

		if ( 'playlist' == version ) {
			showMiniSchedule = true
		}

		return (
			<div className={ className }>
				{ ! ( 'container' in document.documentElement.style ) &&
					<LoadScript src="https://unpkg.com/container-query-polyfill/cqfill.iife.min.js" />
				}

				<ErrorBoundary>
					<SitePlayer { ...this.props } siteidOverride={ siteid } />
				</ErrorBoundary>

				{ ( siteNotice && siteNotice.isOpen ) &&
					<SiteNotice
						heading={ siteNotice.heading }
						text={ siteNotice.text }
						cancelText={ siteNotice.cancelText }
						handleCancel={ null }
					>
						<div className="-actions">
							<a href={ `${siteData.site_url}/signin` } target="_blank" rel="noopener">Log in or Sign up</a>
						</div>
					</SiteNotice>
				}

				<div className="-logo">
					<a href={ siteData.site_url } target="_blank" rel="noopener">
						<img className="site-logo" src={ `${siteData.images_url}logo/faithfm-r4.svg` } alt="" />
					</a>
				</div>

				<ErrorBoundary>
					<NowPlaying
						showMiniSchedule={ showMiniSchedule }
						programClickPlayDirect={ true }
						showLikeButtons={ false }
						openLinksInTab={ true }
					/>
				</ErrorBoundary>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		siteNotice: state.site.siteNotice
	}
}

export default connect( mapStateToProps )( EmbeddedPlayer )
